var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 15,
    fill: "none",
    viewBox: "0 0 49 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#273991",
    d: "M9.267 7.725l-1.33-6.433A1.575 1.575 0 006.204.11H.047L0 .418c4.787 1.15 7.952 3.937 9.267 7.307zM13.74.252l-3.89 9.93-.402-1.497a15.566 15.566 0 00-5.511-6.031l3.55 12.133h4.198L17.936.252H13.74zm5.81 0L17.07 14.82h3.937L23.495.252H19.55zm26.055 0h-3.087a1.969 1.969 0 00-2.079 1.213l-5.865 13.338h4.165s.677-1.795.834-2.189h5.079c.118.504.48 2.173.48 2.173h3.685L45.605.252zm-4.89 9.386c.33-.835 1.575-4.07 1.575-4.07s.33-.835.527-1.387l.276 1.252.913 4.205h-3.291zm-9.22-3.551c-1.378-.67-2.228-1.126-2.22-1.803.007-.677.716-1.252 2.267-1.252a7.15 7.15 0 012.968.559l.363.165.535-3.15A10.15 10.15 0 0031.857 0c-3.937 0-6.685 1.969-6.708 4.803 0 2.087 1.968 3.26 3.472 3.937s2.087 1.173 2.087 1.811c0 .977-1.237 1.425-2.363 1.425a8.33 8.33 0 01-3.732-.787l-.512-.236-.559 3.26c1.416.527 2.915.794 4.425.787 4.166 0 6.874-1.953 6.906-4.976-.008-1.638-1.063-2.898-3.378-3.937z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCardIcon);
export default __webpack_public_path__ + "static/media/visaCardIcon.58e792ce157d2a4833a80e08dafd788f.svg";
export { ForwardRef as ReactComponent };